<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <h1 class="pt-3 mb-3">Waitlist Options</h1>
  <form *ngIf="waitlistOptionsForm" [formGroup]="waitlistOptionsForm" (ngSubmit)="submitWaitlistOptionsForm(waitlistOptionsForm.value)">
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">Default page</label>
        <p>Specify the default page.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <frontend-dropdown
          elementId="default-page"
          formControlName="defaultPage"
          name="defaultPage"
          [items]="defaultPageOptions"
          bindLabel="name"
          bindValue="value"
        ></frontend-dropdown>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-wait" class="lead col-form-label">Default wait time (mins)</label>
        <p>Set this to your most commonly quoted wait, or to 0 if you don't want to quote waits.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <input
          type="number"
          class="form-control"
          id="settings-wait"
          formControlName="default_quoted_time"
          name="defaultQuotedTime"
          min="0"
          [class.is-invalid]="waitlistOptionsForm.get('default_quoted_time').invalid && waitlistOptionsForm.get('default_quoted_time').touched"
        />
      </div>
    </div>
    <div class="row form-group" *ngIf="waitlistOptionsForm.get('waitFields.size').value">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-party-size" class="lead col-form-label">Default {{ location.displayOptions.labels.customer }} size</label>
        <p>Set this to your most common group size.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <input type="number"
               id="settings-party-size"
               class="form-control"
               formControlName="default_size"
               name="defaultSize"
               numbers-only-pattern-validator="non-negative"
               pattern="\d*"
               [class.is-invalid]="waitlistOptionsForm.get('default_size').invalid && waitlistOptionsForm.get('default_size').touched">
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">Sort {{ location.displayOptions.labels.customer_plural }} by</label>
        <p>You can sort your waitlist by default by arrival time or by what time you quoted. Sorting by quoted time makes it easier
          to track things if you quote different sized groups different wait times.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <frontend-dropdown
          elementId="settings-sort"
          formControlName="waitListSortBy"
          name="waitListSortBy"
          [items]="waitListSortByOptions"
          bindValue="value"
          bindLabel="name"
          customClass="text-nowrap"
        ></frontend-dropdown>
      </div>
    </div>
    <div class="row form-group" *ngIf="false">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-serving-tracking" class="lead col-form-label">Serving Tracking</label>
        <p>Track your {{ location.displayOptions.labels.customer_plural }} as you're serving. Assign them to a resource as you move them
          from your waitlist and get a real-time view of your operation.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <div class="form-check">
          <input id="settings-serving-tracking"
                 type="checkbox"
                 formControlName="servingTraking"> Enable
        </div>
      </div>
    </div>
    <div class="row form-group" *ngIf="false">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="reservation-resource" class="lead col-form-label">
          {{location.resourceSettings.label | titlecase}} selection required
        </label>
        <p>Force selection of a {{location.resourceSettings.label || "resource"}} when marking as served.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <label class="form-check-label">
          <input type="checkbox"
                 class="form-check-input"
                 id="reservation-resource"
                 formControlName="resourceSelection"
                 name="resourceSelection"> Enable
        </label>
      </div>
    </div>
    <div class="row form-group" formGroupName="waitFields">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-show-quoted" class="lead col-form-label">Wait fields to display</label>
        <p>Choose which columns to have in your private waitlist.</p>
      </div>
      <div class="mt-2 pl-3">
        <div class="form-check" *ngFor="let option of waitFieldsOptions">
          <label class="form-check-label">
            <input type="checkbox" id="settings-show-quoted" class="form-check-input" [formControlName]="option.id"> {{ option.name }}
            <span class="bi bi-info-circle-fill info-badge ml-1" data-toggle="tooltip" data-placement="top" title="{{ option.hover }}"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">Auto-remove waiting {{ location.displayOptions.labels.customer_plural }} from your list after</label>
        <p>Clear out everything on your waitlist after a certain amount of time.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <frontend-dropdown
          elementId="settings-auto-remove"
          formControlName="autoRemove"
          name="autoRemove"
          bindLabel="name"
          bindValue="value"
          [items]="autoRemoveOptions"
        ></frontend-dropdown>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="col-form-label lead">Note options</label>
        <p>If you would like to use your "notes" field to have a drop-down list of options that you can select, such as table
          number or section, walk-in type (call ahead, etc.), provider name, auto make, etc., you can enter the predefined
          options here. You can still enter custom notes for each group.</p>
      </div>
      <div class="col-sm-5 mt-2">
        <frontend-dropdown-plain
          #noteOptions
          elementId="noteOptionsDropdown"
          class="w-100"
          [items]="location.noteOptions || []"
          [addTag]="true"
          [multiple]="true"
          formControlName="noteOptions"
          [placeholder]="'Select notes'"
          [clearable]="true"
        ></frontend-dropdown-plain>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-3 offset-sm-4">
        <button class="btn btn-info"
                type="submit"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Wait List Settings"
                [disabled]="waitlistOptionsForm.pristine || !waitlistOptionsForm.valid">Save
        </button>
      </div>
    </div>
  </form>
  <h2 class="pt-3 mb-3">Display options</h2>
  <form *ngIf="displayOptionsForm" [formGroup]="displayOptionsForm" (ngSubmit)="submitDisplayOptionsForm(displayOptionsForm.value)">
    <div formGroupName="labels">
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label class="lead col-form-label">Customer label</label>
          <p>Label you want to use throughout the app for your customer.</p>
        </div>
        <div class="col-sm-5 mt-2">
          <frontend-dropdown-plain
            elementId="settings-displaylabel-customer"
            formControlName="customer"
            [items]="customerLabelOptions"
          ></frontend-dropdown-plain>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label class="lead col-form-label">Quoted time label</label>
          <p>Label you want to use throughout the app for your estimated or quoted time.</p>
        </div>
        <div class="col-sm-5 mt-2">
          <frontend-dropdown-plain
            elementId="settings-displaylabel-quoted"
            formControlName="quoted"
            [items]="quotedLabelOptions"
          ></frontend-dropdown-plain>
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="display-compact" class="col-form-label">Use compact view for waitlist, {{location.displayOptions.labels.reservation_plural}}, and {{location.displayOptions.labels.customer_plural}} tables.</label>
      </div>
      <div class="col-sm-7 d-flex align-items-center">
        <label class="form-check-label">
          <input
            type="checkbox"
            class="form-check-input"
            name="compactEnabled"
            id="display-compact"
            formControlName="compact">Enabled
        </label>
      </div>
    </div>
    <div>
      <div class="row form-group">
        <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
          <label for="display-footer" class="col-form-label">Show count of waiting {{location.displayOptions.labels.customer_plural}} by {{location.displayOptions.labels.customer}} size in the wait list footer</label>
        </div>
        <div class="col-sm-7 d-flex align-items-center">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name="footerEnabled"
              id="display-footer"
              formControlName="footer">Enabled
          </label>
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="display-future" class="col-form-label">Show {{location.displayOptions.labels.customer_plural}} more than 12+ hours in future</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex align-items-center">
        <label class="form-check-label">
          <input type="checkbox"
                 class="form-check-input"
                 name="futureEnabled"
                 id="display-future"
                 formControlName="future">Enabled
        </label>
      </div>
    </div>
    <div *ngIf="account.features?.togo" class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="enable-togo" class="col-form-label">Enable a separate carryout/to-go list</label>
      </div>
      <div class="col-sm-7 d-flex align-items-center">
        <label class="form-check-label">
          <input
            id="enable-togo"
            type="checkbox"
            class="form-check-input"
            name="togo"
            formControlName="togo"
          >Enabled
        </label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label class="lead col-form-label">Display notification times as:</label>
      </div>
      <div class="col-sm-5 mt-2">
        <frontend-dropdown-plain
          elementId="settings-notification-time"
          formControlName="notificationTime"
          [items]="notificationTimeOptions"
        ></frontend-dropdown-plain>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-3 offset-sm-4 mt-3">
        <button class="btn btn-info"
                type="submit"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Display Settings"
                [disabled]="displayOptionsForm.pristine || !displayOptionsForm.valid">Save
        </button>
      </div>
    </div>
  </form>

</section>
